import { render, staticRenderFns } from "./DSPageLayout.vue?vue&type=template&id=02c85468&scoped=true&"
import script from "./DSPageLayout.vue?vue&type=script&lang=ts&"
export * from "./DSPageLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c85468",
  null
  
)

export default component.exports